import { AppBar, Avatar, Box, ListItemButton, ListItemIcon, ListItemText, Stack, Tab, Tabs, TextField, Toolbar, Typography, useScrollTrigger } from '@mui/material'
import { Link } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { Bell, UserCircle } from '@phosphor-icons/react'
import './style.css'
import StudentRecord from './index'
import DoughnutChart from './DoughnutChart'
import httpClient from '../../_util/api'
import Notifications from '../../shared/Notifications/Notification'
import Profile from '../../shared/Profile/Profile'


const Application = () => {
    const [value, setValue] = React.useState(0);
    const [noOfApplications,setNoOfApplications] = useState([])
    const role = localStorage.getItem('role')
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getNoOfApplications = async()=>{
        const res = await httpClient.get(role === 'al-kauser Admin' ? '/students/noOfApplicationsAlKauserAdmin' : '/students/noOfApplications').catch((error)=>{
            console.log(error.message);
        })

        if(res?.status === 200){
            setNoOfApplications(res?.data)
        }
    }

    useEffect(()=>{ 
        getNoOfApplications()
    },[])


    return (
        <>
            <AppBar sx={{
                backgroundColor: '#22663D'
            }}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} sx={{ width: '100%' }}>
                    <Stack sx={{ width: '80%' }}>
                        <Typography sx={{ fontSize: "30px" }}>Al Kauser</Typography>
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '6%' }}>
                        <ListItemButton  >
                                <Notifications />
                        </ListItemButton>

                        <ListItemButton >
                            <ListItemIcon><Profile/></ListItemIcon>
                        </ListItemButton>
                    </Stack>
                </Stack>

                {/* </Toolbar> */}
            </AppBar >
            <Stack justifyContent={'space-around'} sx={{ width: '100%', marginTop: '45px', backgroundColor: '#FCF8ED' }}>
                <Typography sx={{ width: '12%', textAlign: 'center' }}>Application</Typography>
            </Stack>

            <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '100%', height: '90.2vh', backgroundColor: '#22663D' }}>
                <Stack flexDirection={'row'} justifyContent={'space-between'} sx={{ width: '93%', height: '83vh', backgroundColor: '#22663D' }}>
                    <Stack justifyContent={'space-between'} sx={{ width: '45%', height: '100%', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="In Progress" />
                            <Tab label="Approved" />
                            <Tab label="Rejected" />
                            <Tab label="Returned Student"/>

                        </Tabs>
                        <Stack alignItems={'center'} sx={{ width: '100%' , height:'90%'}}>
                            <StudentRecord value={value}  />
                        </Stack>
                    </Stack>

                    <Stack alignItems='center' justifyContent={'center'} sx={{ width: '26%', height: '50vh', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Stack sx={{ width: '89%', height: '95%' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>Applications To Review</Typography>
                            <Stack alignItems='center' justifyContent={'center'} sx={{height:'82%'}}>
                                <Typography variant='h1'>{noOfApplications[1]}</Typography>
                            </Stack>
                        </Stack>

                    </Stack>

                    <Stack alignItems={'center'} justifyContent={'space-around'} sx={{ width: '26%', height: '50vh', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Stack sx={{ width: '89%', height: '95%' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>Total Applications</Typography>
                            <Stack alignItems='center' justifyContent={'center'} sx={{height:'82%'}}>
                                <DoughnutChart chartData={noOfApplications} />
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>
            </Stack>
        </>
    )
}

export default Application